import PreloadIMAGES from "@insightfulscience/smart-react/PreloadImages";
import { publicConfig } from "@src/config";

interface Props {
	imagesHref?: string[];
}

const assetUrl = `${publicConfig.SB_CDN_HOST}${publicConfig.SB_CDN_BASE_URL}/assets`;

const PreloadImages = ({ imagesHref = [] }: Props) => (
	<PreloadIMAGES
		host={assetUrl}
		imagesHref={[
			"/images/dotmatics/omiq/logo/logo-omiq-simple.svg",
			"/images/common/dotmatics-logo-white.svg",
			...imagesHref,
		]}
	/>
);

export default PreloadImages;
